module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{},"es":{"title":"Conoce las últimas tendencias en aceptación de pagos."}}')
  delete Component.options._Ctor
}
